<template>
	<ui-modal name="add-success">
		<div class="container-modal-add-success">
			<div class="container-modal-content">
				<div class="circle-check">
					<em class="fal fa-check" />
				</div>
				<div class="modal-content-line">
					<p class="modal-content-line-title">
						<span class="modal-content-line-title-integration">Integração {{ typeComputed }} </span>
						realizada com sucesso!
					</p>
					<p class="modal-content-line-subtitle">O que você deseja fazer agora?</p>
				</div>
			</div>

			<ui-actions-deals-wrapper-list v-model="actions" />

			<ui-button :disabled="!activeAction"
				design="primary xxxl mw-150"
				style="margin-top: 20px"
				@click="next">
				Avançar
			</ui-button>
		</div>
	</ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiActionsDealsWrapperList } from '@/components/ui-facilita/wrapper'

	import { mapGetters } from 'vuex'

	const defaultActionList = () => [
		{
			id: 1,
			name: 'Integrar nova Disponibilidade',
			action: 'redirect--availability',
			check: false,
		},
		{
			id: 2,
			name: 'Mapear campos para envio da proposta ERP',
			action: 'redirect--map-proposal',
			check: false,
		},
	]

	export default {
		name: 'modal-add-success',

		components: {
			uiModal,
			uiButton,
			uiActionsDealsWrapperList
		},

		data() {
			return {
				actions:[...defaultActionList()]
			}
		},

		computed: {
			...mapGetters('ERP', {
				integration: 'getSelected'
			}),
			/**
			 * Computed property que retorna a action selecionada
			 */
			activeAction() {
				return this.actions[0]
  			},
			/**
			 * Computed property que retorna o tipo da integração que foi cadastrada
			 */
			typeComputed() {
				return this.integration ? this.integration.type : ''
			}
		},

		watch: {
			typeComputed(newType) {
				if (newType === 'uau') {
					this.actions = [this.actions.find(action => action.id === 1)]
				} else if (newType === 'informakon') {
					this.actions = [this.actions.find(action => action.id === 2)]
				} else {
					// Defina ações padrão ou vazias para outros tipos de integração
					this.actions = []
				}
  			}
		},

		methods: {
			/**
			 * Executa a ação selecionada
			 */
			next() {
				switch (this.activeAction.action) {
					case 'redirect--availability':
						this.$router.push({ name: 'marketing.integrations.erp.availability' })
						break
				
					case 'redirect--map-proposal':
						this.$router.push({ name: 'marketing.integrations.erp.map_proposal', params: { id: this.integration.id } })
						break
				}
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
